// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import Topbar from "../../components/Topbar/Topbar";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  toggle_off,
  toggle_on,
} from "../../assets/img";
import { toast } from "react-toastify";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { customFilterOption } from "../../components/StaticData";
import { EMAIL } from "../redux/api/Constants";

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    borderColor: "#ccc",
    boxShadow: "none",
    padding: "4px 8px",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: 160,
    overflowY: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 160, // scrolling height
    overflowY: "auto", // enable scroll
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: state.isFocused ? "#f0eaff" : "#fff",
    color: "#000",
    padding: "10px",
  }),
};

const formatOptionLabel = ({ label, code }) => (
  <div
    style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
  >
    <span>{label}</span>
    <span style={{ fontWeight: 600 }}>{code}</span>
  </div>
);

const ReceptionistAction = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ScrollRef = useRef(null);
  const type = location?.state?.type || "add"; // view | edit | add
  const [idd, setIdd] = useState(location?.state?.id || "");
  const [deletePopup, setDeletePopup] = useState(false);

  const [selectedOwner, setSelectedOwner] = useState(null);
  const [receptionists, setReceptionists] = useState([]);
  const [editId, setEditId] = useState("");
  const imgRef = useRef(null);
  const [profile_img, setProfile_img] = useState("");
  const [gender, setGender] = useState(null);

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      mobile: "",
      whatsapp: "",
      sameAsMobile: false,
    },
  });

  const [ownerOptions, setOwnerOptions] = useState([]);

  // Fetch Owner List
  const fetchOwnerList = async () => {
    const res = await get(URLS.OWNERS_DROPDOWN);
    console.log("owners dropdown", res);
    if (res?.status === "success") {
      const formattedOwners = res.data.map((owner) => ({
        value: owner.id,
        label: owner.name,
        code: owner.code,
      }));
      setOwnerOptions(formattedOwners);
    }
  };
  const getReceptionistList = async (id) => {
    const res = await get(URLS.RECEPTION + id);
    console.log("receptionist list", res);
    if (res?.status === "success") {
      setReceptionists(res?.data);
      let d = res?.data?.[0];
      if (d) {
        setSelectedOwner({
          value: d.owner_id,
          label: d.owner_name,
          code: d.owner_code,
        });
      }
    } else {
      setReceptionists([]);
    }
  };

  useEffect(() => {
    // if (!idd) {
    fetchOwnerList();
    // }
    if (idd) {
      getReceptionistList(idd);
    }
  }, [idd]);

  const sameAsMobile = watch("sameAsMobile");
  const mobileNumber = watch("mobile");

  useEffect(() => {
    if (sameAsMobile) {
      setValue("whatsapp", mobileNumber);
    }
  }, [sameAsMobile, mobileNumber, setValue]);

  const onSubmit = async (data) => {
    if (type === "add") {
      if (!selectedOwner) {
        toast.error("Please select owner name");
        return;
      }
    }
    if (!gender?.value) {
      toast.error("please select your gender");
      return;
    }

    let formdata = new FormData();
    formdata.append("name", data.name);
    formdata.append("email", data.email);
    formdata.append("mobile", data.mobile);
    formdata.append("whatsapp_no", data.whatsapp);
    if (typeof profile_img !== "string") {
      formdata.append("image", profile_img);
    }
    formdata.append("gender", gender?.value);

    if (!editId) {
      formdata.append("owner", selectedOwner?.value);
      const res = await post(`${URLS.RECEPTION}add/`, formdata);
      if (res.status === "success") {
        toast.success(res.message || "Added successfully");
        reset();
        setProfile_img("");
        setGender(null);
        setSelectedOwner(null);
        getReceptionistList(selectedOwner?.value);
        setIdd(selectedOwner?.value);
      }
    } else {
      formdata.append("owner_id", idd);
      const res = await post(`${URLS.RECEPTION}${editId}/edit/`, formdata);
      if (res.status === "success") {
        toast.success(res.message || "Updated successfully");
        setEditId("");
        reset();
        setProfile_img("");
        setGender(null);
        setSelectedOwner(null);
        getReceptionistList(idd);
      }
    }
  };
  const handleEdit = (data) => {
    console.log("data edit");
    ScrollRef.current?.scrollIntoView({ behavior: "smooth" });
    setValue("name", data.name);
    setValue("email", data.email);
    setValue("mobile", data.mobile);
    setValue("whatsapp", data.whatsapp_no);
    setValue("sameAsMobile", data.mobile === data.whatsapp_no);
    setSelectedOwner({
      value: data.owner_id,
      label: data.owner_name,
      code: data.owner_code,
    });
    setProfile_img(data?.image);
    setGender({ value: data?.gender, label: data?.gender });
  };

  const handleDelete = async (id) => {
    const res = await post(URLS.RECEPTION + id + "/delete/");
    console.log("reception status", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getReceptionistList(idd);
      setDeletePopup(false);
    }
  };
  const handleStatus = async (id, status) => {
    const res = await post(URLS.RECEPTION + id + "/status/", {
      status: status === 1 ? 2 : 1,
    });
    console.log("reception status", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getReceptionistList(idd);
    }
  };

  return (
    <div ref={ScrollRef} className="p-3">
      <Topbar
        header={
          type === "view"
            ? "Receptionist View"
            : type === "edit"
            ? "Receptionist Edit"
            : "Receptionist Add"
        }
      />

      {/* Owner Select */}
      <div className="mb-4" style={{ maxWidth: 395 }}>
        <label className="mb-1 fw-bold">Owner</label>
        <Select
          value={selectedOwner}
          onChange={(e) => setSelectedOwner(e)}
          options={ownerOptions}
          placeholder="Select Owner"
          isClearable
          isSearchable
          styles={customStyles}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          isDisabled={type === "view" || idd}
        />
      </div>

      {(type === "edit" || type === "add") && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* profile image */}
            <div className="col-md-6 mb-3">
              <label className="fw-semibold">Profile Image</label>
              <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red">
                Max Upload Size : 5MB and Banner Size 1200px 700px, Max 10
                image*
              </p>
              <div className="d-flex flex-column as-jc position-relative">
                <img
                  onClick={() => imgRef.current?.click()}
                  src={
                    profile_img
                      ? typeof profile_img === "string"
                        ? profile_img
                        : URL.createObjectURL(profile_img)
                      : dummyimage
                  }
                  style={{
                    width: "100px",
                    height: "90px",
                    borderRadius: "50px",
                  }}
                  alt=""
                />
                <input
                  ref={imgRef}
                  type="file"
                  className="input-pop mt-2 w-100 d-none"
                  accept="image/*"
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                      setProfile_img(e.target.files[0]);
                    }
                  }}
                />
                {/* {!profile_img &&  (
                  <p className="err">Upload image</p>
                )} */}
              </div>
            </div>

            {/*  gender */}
            <div className="col-md-6 mb-3">
              <label className="fw-semibold">
                Gender <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                options={genderOptions}
                value={gender}
                onChange={(e) => {
                  setGender(e);
                }}
                placeholder="Select Gender"
                styles={customStyles}
              />
            </div>

            {/* Name */}
            <div className="col-md-6 mb-3">
              <label className="fw-semibold">
                Receptionist Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="form-controls"
                placeholder="Enter name"
                {...register("name", {
                  required: "Receptionist Name is required",
                })}
                disabled={type === "view"}
              />
              {errors.name && (
                <p className="err text-danger">{errors.name.message}</p>
              )}
            </div>

            {/* Email */}
            <div className="col-md-6 mb-3">
              <label className="fw-semibold">
                Email ID <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="form-controls"
                placeholder="Enter email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: EMAIL,
                    message: "Invalid email address",
                  },
                })}
                disabled={type === "view"}
              />
              {errors.email && (
                <p className="err text-danger">{errors.email.message}</p>
              )}
            </div>

            {/* Mobile */}
            <div className="col-md-6 mb-3">
              <label className="fw-semibold">
                Contact Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="form-controls"
                placeholder="Enter 10-digit number"
                type="text"
                maxLength={10}
                {...register("mobile", {
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Must be exactly 10 digits",
                  },
                })}
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                disabled={editId}
              />
              {errors.mobile && (
                <p className="err text-danger">{errors.mobile.message}</p>
              )}
            </div>

            {/* WhatsApp */}
            <div className="col-md-6 mb-3">
              <label className="fw-semibold">
                WhatsApp Number <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ position: "relative" }}>
                <input
                  className="form-controls"
                  placeholder="Enter WhatsApp number"
                  type="text"
                  maxLength={10}
                  {...register("whatsapp", {
                    required: "WhatsApp number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Must be exactly 10 digits",
                    },
                  })}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  disabled={type === "view" || sameAsMobile}
                />
                {/* <div
                  style={{ position: "absolute", right: "15px", top: "5px" }}
                >
                  <img
                    src={Purple_Dot}
                    alt=""
                    style={{ width: "15px", height: "15px" }}
                  />
                </div> */}
              </div>
              {errors.whatsapp && (
                <p className="err text-danger">{errors.whatsapp.message}</p>
              )}
              <div className="mt-1">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("sameAsMobile")}
                    disabled={type === "view"}
                  />
                  <span className="text-muted">Same as mobile</span>
                </label>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-between mt-4">
            <button
              type="button"
              className="backbutton f2"
              onClick={() => navigate("/receptionist")}
            >
              Back
            </button>
            {type !== "view" && (
              <button type="submit" className="submit-btn f2 w-10">
                {editId ? "Update" : "Add"}
              </button>
            )}
          </div>
        </form>
      )}

      {/* Receptionist List */}
      {receptionists.length > 0 && (
        <div className="mt-5">
          {receptionists.map((rec, index) => (
            <div
              key={index}
              className="p-3 mb-3"
              style={{ border: "1px solid #ddd", borderRadius: "8px" }}
            >
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex gap-3">
                  <h6 className="m-0">Receptionist {index + 1}</h6>
                  <img
                    src={rec?.status === 1 ? toggle_on : toggle_off}
                    className="roles-icon pointer"
                    alt=""
                    onClick={() => {
                      if (type !== "view") {
                        handleStatus(rec.id, rec?.status);
                      }
                    }}
                  />
                </div>
                {type !== "view" && (
                  <div className="d-flex gap-3">
                    <button
                      onClick={() => {
                        handleEdit(rec);
                        setEditId(rec?.id);
                      }}
                      className="cust-btn"
                    >
                      <img src={edit_icon} alt="" className="mx-2 edit-btn" />
                    </button>
                    <button
                      onClick={() => {
                        setDeletePopup(rec);
                      }}
                      className="cust-btn"
                    >
                      <img src={delete_icon} alt="" className="mx-2 edit-btn" />
                    </button>
                  </div>
                )}
              </div>

              <div className="row">
                {/* profile image */}
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">Profile Image</label>
                  <div className="d-flex flex-column as-jc position-relative">
                    <img
                      onClick={() => imgRef.current?.click()}
                      src={rec?.image ?? dummyimage}
                      style={{
                        width: "100px",
                        height: "90px",
                        borderRadius: "50px",
                      }}
                      alt=""
                    />
                  </div>
                </div>

                {/*  gender */}
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">Gender</label>
                  <input
                    className="form-controls"
                    value={rec.gender}
                    disabled
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">Receptionist Name</label>
                  <input className="form-controls" value={rec.name} disabled />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">Receptionist ID</label>
                  <input className="form-controls" value={rec.code} disabled />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">Email ID</label>
                  <input className="form-controls" value={rec.email} disabled />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">Contact Number</label>
                  <input
                    className="form-controls"
                    value={rec.mobile}
                    disabled
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">WhatsApp Number</label>
                  <div style={{ position: "relative" }}>
                    <input
                      className="form-controls"
                      value={rec.whatsapp_no}
                      disabled
                    />
                    {/* <div
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "5px",
                      }}
                    >
                      <img
                        src={Purple_Dot}
                        alt=""
                        style={{ width: "15px", height: "15px" }}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              {deletePopup?.mapped
                ? "This Receptionist is Already Mapped in Another Property "
                : "Are you sure, want to Delete?"}
            </p>
            <div
              className={`d-flex ${
                deletePopup?.mapped ? "ac-jc" : "ac-jb"
              } px-2 mt-5`}
            >
              {!deletePopup?.mapped && (
                <button
                  onClick={() => handleDelete(deletePopup?.id)}
                  className="add-btn w-40"
                >
                  Yes
                </button>
              )}
              <button
                onClick={() => {
                  setDeletePopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}
                {deletePopup?.mapped ? "Cancel" : "No"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceptionistAction;
